const rounds = [
    {
        arena: {
            id: '01_karelia',
            name: 'Karelia',
        },
        fort_battle_state: [
            {
                attacker_clan_id: null,
                owner_clan_id: 1061,
                arena_id: 1,
            },
            {
                attacker_clan_id: null,
                owner_clan_id: 1061,
                arena_id: 2,
            },
            {
                attacker_clan_id: 1062,
                owner_clan_id: 1061,
                arena_id: 3,
            },
            {
                attacker_clan_id: null,
                owner_clan_id: 1062,
                arena_id: 6,
            },
            {
                attacker_clan_id: null,
                owner_clan_id: 1062,
                arena_id: 4,
            },
            {
                attacker_clan_id: null,
                owner_clan_id: 1062,
                arena_id: 1,
            },
        ],
        finish_reason: 'EXTERMINATION',
        battle_duration: 49,
        is_win: false,
        is_draw: false,
        reward: {
            total: 0,
            clan_efficiency: 0,
            legionary: 345,
            high_capacity_transport: {
                percent: 5,
                value: 0,
            },
            airstrike: {
                percent: 5,
                value: 0,
            },
            artillery_strike: {
                percent: 5,
                value: 0,
            },
            inspiration: {
                percent: 10,
                value: 100,
            },
        },
        score: [3, 14],
    },
    {
        arena: {
            id: '04_himmelsdorf',
            name: 'Himmelsdorf',
        },
        fort_battle_state: [
            {
                attacker_clan_id: null,
                owner_clan_id: 1061,
                arena_id: 1,
            },
            {
                attacker_clan_id: 1062,
                owner_clan_id: 1061,
                arena_id: 2,
            },
            {
                attacker_clan_id: null,
                owner_clan_id: 1062,
                arena_id: 3,
            },
            {
                attacker_clan_id: null,
                owner_clan_id: 1062,
                arena_id: 6,
            },
            {
                attacker_clan_id: null,
                owner_clan_id: 1062,
                arena_id: 4,
            },
            {
                attacker_clan_id: null,
                owner_clan_id: 1062,
                arena_id: 1,
            },
        ],
        finish_reason: 'TECHNICAL',
        battle_duration: 0,
        is_win: false,
        is_draw: false,
        reward: {
            total: 0,
            clan_efficiency: 0,
            legionary: 120,
            high_capacity_transport: {
                percent: 5,
                value: 0,
            },
            airstrike: {
                percent: 5,
                value: 0,
            },
            artillery_strike: {
                percent: 5,
                value: 0,
            },
        },
        score: [0, 0],
    },
    {
        arena: {
            id: '02_malinovka',
            name: 'Malinovka',
        },
        fort_battle_state: [
            {
                attacker_clan_id: 1062,
                owner_clan_id: 1061,
                arena_id: 1,
            },
            {
                attacker_clan_id: null,
                owner_clan_id: 1062,
                arena_id: 2,
            },
            {
                attacker_clan_id: null,
                owner_clan_id: 1062,
                arena_id: 3,
            },
            {
                attacker_clan_id: null,
                owner_clan_id: 1062,
                arena_id: 6,
            },
            {
                attacker_clan_id: null,
                owner_clan_id: 1062,
                arena_id: 4,
            },
            {
                attacker_clan_id: null,
                owner_clan_id: 1062,
                arena_id: 1,
            },
        ],
        finish_reason: 'TECHNICAL',
        battle_duration: 0,
        is_win: false,
        is_draw: false,
        reward: {
            total: 0,
            clan_efficiency: 0,
            legionary: 0,
            high_capacity_transport: {
                percent: 5,
                value: 0,
            },
            airstrike: {
                percent: 5,
                value: 0,
            },
            artillery_strike: null,
        },
        score: [0, 0],
    },
    {
        arena: {
            id: '01_karelia',
            name: 'Karelia',
        },
        fort_battle_state: [
            {
                attacker_clan_id: null,
                owner_clan_id: 1062,
                arena_id: 1,
            },
            {
                attacker_clan_id: null,
                owner_clan_id: 1062,
                arena_id: 2,
            },
            {
                attacker_clan_id: null,
                owner_clan_id: 1062,
                arena_id: 3,
            },
            {
                attacker_clan_id: null,
                owner_clan_id: 1062,
                arena_id: 6,
            },
            {
                attacker_clan_id: null,
                owner_clan_id: 1062,
                arena_id: 4,
            },
            {
                attacker_clan_id: null,
                owner_clan_id: 1062,
                arena_id: 1,
            },
        ],
        finish_reason: 'TECHNICAL',
        battle_duration: 0,
        is_win: false,
        is_draw: false,
        reward: {
            total: 0,
            clan_efficiency: 0,
            legionary: 0,
            high_capacity_transport: {
                percent: 5,
                value: 0,
            },
            airstrike: null,
            artillery_strike: {
                percent: 5,
                value: 0,
            },
        },
        score: [2, 5],
    },
]

export default {
    own_clan_id: 1061,
    enemy_clan_id: 1062,
    direction: 'A',
    enemy_clan: {
        id: 6,
        name: 'Aver',
        tag: 'AVER',
        color: '#005e89',
        emblem: 'http://ru.wgnwn.wgnt.iv/sclans/media/clans/emblems/cl_6/6/emblem_24x24.png',
    },
    rounds,
    result: {
        is_win: false,
        is_draw: true,
        finish_reason: 'EXTERMINATION',
        points_under_control: 3,
        reward: {
            points_under_control: 0,
            series: 0,
            total: 450,
            first_victory_on_direction: 0,
            legionary: 30,
            requisition: {
                percent: 5,
                value: 0,
            },
        },
    },
}



// WEBPACK FOOTER //
// ./containers/PostbattleScreen/mock.js